<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            <template v-if="!$page.props.submitted_a2p">
                Your Organization Needs to Get Verified
            </template>
            <template v-else>
                A2P Application Under Review
            </template>    

        </template>

        <template #content>
            <div>
                Thank you for signing up for a TextSpot plan.
            </div>
            <div class="mb-2 mt-2">
                <template v-if="!$page.props.submitted_a2p">
                    Before you can start messaging your contacts, your organization needs to get verified. <br />
                    We know this is frustrating, but carriers require this to protect against spam. <br />
                    We'll get you registered with carriers so you can send messages to your contacts. <br />
                </template>
                <template v-else>
                    Your A2P application has been submitted and is under review. We will email you with any updates. <br />
                    Thank you for your patience.
                </template>
            </div>
        </template>

        <template #footer>
            <div>
                <jet-button text
                    v-on:click="openIntercom" 
                >
                    Contact Support
                </jet-button>
                    
                <Link :href="route('a2p.start')" @click="$emit('close')" class="w-full text-center">
                    <jet-button secondary class="">
                        <template v-if = "!$page.props.submitted_a2p">
                            Get Verified Now
                        </template>
                        <template v-else>
                            View Status
                        </template>
                    </jet-button>
                </Link>
            </div>
        </template>
    </jet-dialog-modal>

</template>


<script>
import JetDialogModal from '../../Jetstream/DialogModal';
import JetSecondaryButton from '../../Jetstream/SecondaryButton';

export default {
    name: 'YourOrgNeedsToGetVerifiedModal',
    emits: ['close'],
    components: {
        JetDialogModal,
        JetSecondaryButton,
    },
    methods: {
        openIntercom() {
            window.Intercom('showNewMessage');
        }
    },
    computed: {
        formattedNumber() {
            let phoneNumber = this.$page.props.auth.user.organization.phone; 
            //remove the +1 from the number..
            phoneNumber = phoneNumber.replace('+1', '');


            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
    }

}
</script>